import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import { auth } from "../firebase";

export default function AdminEmailSend() {
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [sentEmails, setSentEmails] = useState([]);

    useEffect(() => {
        loadGroups();
        loadSentEmails();
    }, []);

    const loadGroups = async () => {
        try {
            const token = await auth.currentUser.getIdToken();
            const res = await axios.get("/api/emails?active_only=true", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setGroups(res.data);
        } catch (err) {
            toast.error("Failed to load email lists.");
        }
    };

    const loadSentEmails = async () => {
        try {
            const token = await auth.currentUser.getIdToken();
            const res = await axios.get("/api/emails_sent", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setSentEmails(res.data);
        } catch (err) {
            toast.error("Failed to load sent emails.");
        }
    };

    const handleSend = async () => {
        if (!selectedGroup || !subject || !message) {
            toast.warning("All fields are required.");
            return;
        }

        try {
            const token = await auth.currentUser.getIdToken();
            await axios.post(`/api/emails/${selectedGroup}/send`, { subject, message }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Email sent!");
            setSubject("");
            setMessage("");
            loadSentEmails();
        } catch (err) {
            toast.error("Failed to send email.");
        }
    };

    return (
        <div className="container mt-3">
            <h4>Send Email to List</h4>

            <div className="mb-2">
                <label>List</label>
                <select className="form-select" value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)}>
                    <option value="">Select a list</option>
                    {groups.map((g) => (
                        <option key={g._id} value={g._id}>
                            {g.group_name} ({g.members.length})
                        </option>
                    ))}
                </select>
            </div>

            <div className="mb-2">
                <label>Subject</label>
                <input type="text" className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} />
            </div>

            <div className="mb-3">
                <label>Message</label>
                <ReactQuill
                    theme="snow"
                    value={message}
                    onChange={setMessage}
                    modules={{
                        toolbar: [
                            ["bold", "italic"],
                            ["link", "image"],
                            [{ header: [1, 2, false] }],
                            [{ list: "bullet" }]
                        ]
                    }}
                    formats={["bold", "italic", "link", "image", "list", "bullet", "header"]}
                    style={{ minHeight: "200px" }}
                />
            </div>

            <button className="btn btn-admin" onClick={handleSend}>Send</button>

            <hr className="my-4" />

            <h4>Previously Sent Emails</h4>
            <table className="table table-bordered mt-3">
                <thead className="table-light">
                    <tr>
                        <th>Subject</th>
                        <th>List</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {sentEmails.map((email) => (
                        <tr key={email._id}>
                            <td>{email.subject}</td>
                            <td>{email.group_name}</td>
                            <td>{moment(email.sent_at).format("MMMM D, YYYY h:mm A")}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
